import MeaPage from "../../../components/MeaPage";
import { useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import useUrlState from "@ahooksjs/use-url-state";
import ScheduleTableComponent from "./components/ScheduleTableComponent";
import ScheduleAssignmentsComponent from "./components/ScheduleAssignmentsComponent";
import { SelectButton } from "primereact/selectbutton";

const SessionsListPage = () => {
  const listRef = useRef();
  const { schoolId, trainingId } = useParams();

  const savedView = localStorage.getItem("mea_schedule_view") || "table";
  const [state, setState] = useUrlState({
    view: savedView,
  });

  const view = (state.view || savedView || "table") === "calendar"
    ? "affectations"
    : (state.view || savedView || "table");

  const viewOptions = [
    { label: "Table", value: "table" },
    { label: "Calendrier", value: "affectations" },
  ];

  const handleViewChange = (newView) => {
    if (newView) {
      localStorage.setItem("mea_schedule_view", newView);
      setState({ view: newView });
    }
  };

  useEffect(() => {
    if (state.view) {
      localStorage.setItem("mea_schedule_view", state.view);
    }
  }, [state.view]);

  return (
    <>
      <MeaPage
        title="Programme de la semaine"
        subtitle="Gérer le programme d'une semaine, pour toute l'année"
        customActions={(
          <div>
            <SelectButton
              className="p-0"
              value={view}
              onChange={(e) => handleViewChange(e.value)}
              options={viewOptions}
            />
          </div>
        )}
      >
        {view === "table" && (
          <ScheduleTableComponent
            ref={listRef}
            schoolId={schoolId}
            trainingId={trainingId}
            showAddButton={true}
            showFilterButton={true}
          />
        )}
        {view === "affectations" && (
          <ScheduleAssignmentsComponent
            ref={listRef}
            schoolId={schoolId}
            trainingId={trainingId}
            showAddButton={true}
            showFilterButton={true}
          />
        )}
      </MeaPage>
    </>
  );
};
export default SessionsListPage;
